import { render, staticRenderFns } from "./Report.vue?vue&type=template&id=10807fa3&scoped=true"
import script from "./Report.vue?vue&type=script&lang=js"
export * from "./Report.vue?vue&type=script&lang=js"
import style0 from "./Report.vue?vue&type=style&index=0&id=10807fa3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10807fa3",
  null
  
)

export default component.exports